import { L as LogUtility } from './log-a824be80.js';
import { c as convertToNumber } from './number-400b3bf2.js';

const BASE_BASIC_Z_INDEX = 10000;
const TOP_BASIC_Z_INDEX = 11000;
/**
 * Base level is for custom element such as modal, tooltip, dropdown, sidenav and header.
 * 	the z-index of current showing element is highly than already show.
 * Top level is for element that always display to top, such as notification.
 */
class ZIndexManager {
  constructor() {
    this.levelEntry = {
      base: {
        zIndex: BASE_BASIC_Z_INDEX,
        elements: [],
      },
      top: {
        zIndex: TOP_BASIC_Z_INDEX,
        elements: [],
      },
    };
  }
  /**
   * "If the element is not already the current element, then increment the z-index and set the element
   * to the current element."
   *
   * The function is a little more complicated than that, but not much. The function takes an element and
   * a level. The level is optional and defaults to 'base'. The level is used to keep track of the
   * z-index for each level. The function uses a private variable, levelStatus, to keep track of the
   * current element and z-index for each level
   *
   * @param {HTMLElement} element - The element to set the z-index of.
   * @param {Level} [level=base] - The level of the element.
   * @returns {void}
   */
  setZIndex(element, level = 'base') {
    if (element === null)
      return;
    this.removeZIndex(element, level);
    const zIndexEntry = this.levelEntry[level];
    if (element && zIndexEntry) {
      if (level === 'base' && this.isBaseLevelOver()) {
        LogUtility.warn(`The max 'z-index' of base level is '11000', but the current 'z-index' is over, Please optimize the use of 'z-index', otherwise there will be some performance overhead.`);
        this.increaseTopEntry();
      }
      zIndexEntry.elements.push(element);
      zIndexEntry.zIndex += 1;
      element.style.zIndex = zIndexEntry.zIndex.toString();
    }
  }
  /**
   * It removes the element from the level's array of elements, and then decrements the z-index of all
   * elements after the removed element
   *
   * @param {HTMLElement} element - HTMLElement - The element to move
   * @param {Level} [level=base] - Level = 'base'
   * @returns {void}
   */
  removeZIndex(element, level = 'base') {
    if (element === null)
      return;
    const zIndexEntry = this.levelEntry[level];
    if (element && zIndexEntry) {
      let startAt = -1;
      zIndexEntry.elements.forEach((e, index) => {
        if (e === element)
          startAt = index;
        if (startAt >= 0 && index > startAt) {
          e.style.zIndex = `${convertToNumber(e.style.zIndex) - 1}`;
        }
      });
      if (startAt >= 0) {
        element.style.removeProperty('z-index');
        zIndexEntry.elements.splice(startAt, 1);
        zIndexEntry.zIndex -= 1;
      }
    }
  }
  /**
   * It increases the z-index of all the elements in the top entry by 1
   *
   * @returns {void}
   */
  increaseTopEntry() {
    const topEntry = this.levelEntry['top'];
    topEntry.elements.forEach((element) => {
      element.style.zIndex = `${convertToNumber(element.style.zIndex) + 1}`;
    });
    topEntry.zIndex += 1;
  }
  /**
   * If the z-index of the level is over 1000 greater than the basic z-index of the level, then return
   * true.
   *
   * @returns {boolean} - The zIndexEntry.zIndex - this.getBasicZIndexByLevel(level) >= 1000 is being returned.
   */
  isBaseLevelOver() {
    const baseEntry = this.levelEntry['base'];
    return baseEntry.zIndex >= TOP_BASIC_Z_INDEX;
  }
}
const ZIndexManager$1 = new ZIndexManager();

export { ZIndexManager$1 as Z };
